import React from "react";
import { withStyles } from "@mui/styles";
import { Alert, Snackbar } from "@mui/material";
import { useStyles } from "../../views/buyflow/indexFormStyles";

function NotificationMessage(props) {
  const {
    classes: {},
    message = "",
    onClose = {},
    open = false,
    severity = "success",
  } = props;

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert variant="filled" severity={severity} onClose={onClose}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default withStyles(useStyles, { withTheme: true })(NotificationMessage);
